import PortalRoleTempateWithPortalRoleLnksBoilerplate from "./boilerPlates/templateBoilerplates/PortalRoleTempateWithPortalRoleLnksBoilerplate"
import ratmHash from "./RATMHash"

const cloneRoleTemplate = (RoleTemplateId: number) => {
    const { lookupHashTableItem } = ratmHash
    const bucketItem = lookupHashTableItem(RoleTemplateId, 1)
    if (bucketItem) {
        const cloned = JSON.parse(JSON.stringify(bucketItem))
        return {
            Template: cloned[1].templateItem.Template,
            RoleTemplatePortalRoleLnk: cloned[1].templateItem.RoleTemplatePortalRoleLnk
        }
    }
    return JSON.parse(JSON.stringify(PortalRoleTempateWithPortalRoleLnksBoilerplate))
}

export default cloneRoleTemplate